import { styleSheet } from './styles';
import { css } from 'aphrodite';
import * as React from 'react';

export function ImagePreviewUploader({
	id,
	onChange,
	previewImageUrl,
	onPreviewImageLoaded,
}: {
	id: string;
	onChange: React.ChangeEventHandler<HTMLInputElement>;
	previewImageUrl?: string;
	onPreviewImageLoaded?: () => void;
}) {
	return (
		<div className={css(styleSheet.root)}>
			<label htmlFor={id} className={css(styleSheet.label)}>
				<div className={css(styleSheet.labelInnerDiv)}>
					{previewImageUrl ? (
						<img src={previewImageUrl} className={css(styleSheet.previewImage)} onLoad={onPreviewImageLoaded} />
					) : (
						<p className={css(styleSheet.noImagePlaceholder)}>No Image Added</p>
					)}
					<p className={css(styleSheet.uploadImageLink)}>+ Upload high resolution image</p>
				</div>
				<input accept='image/*' id={id} type='file' className={css(styleSheet.input)} onChange={onChange} />
			</label>
		</div>
	);
}
